export default {
  en: {
    rakeBackPartner: 'RAKEBACK-PARTNER',
  },
  ru: {
    rakeBackPartner: 'РЕЙКБЕК-ПАРТНЕР',
  },
};
